var debitWindow = window
export function openDebitAuthentication(content) {
	if (content === '' || content === undefined || content === null) {
		return false
	} else {
		debitWindow = window.open()
		debitWindow.document.open()
		debitWindow.document.write(content)
		debitWindow.document.close()

		return true
	}
}
export function closeDebitAuthentication() {
	debitWindow.close()
}
